import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-sd-bridge-summary-report',
    templateUrl: './sdBridgeSummaryReport.html',
    styleUrls: ['../../reports.css', './sdBridgeSummaryReport.css']
})

export class SDBridgeSummaryReportComponent implements OnInit {

    private bridgeKeys: any[];
    reportData;
    private readonly todaysDate = new Date().toDateString();
    private readonly headers = [
        'Bridge Owner',
        'Structurally Deficient',
        'Structurally Deficient Deck Area (sq. ft)',
        'Non Structurally Deficient',
        'Non Structurally Deficient Deck Area (sq. ft)'
    ];
    isGenerating = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Poor Bridge Condition Summary Report');
    }

    async ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            this.bridgeKeys = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeKeys;
            this.loadReport();
        });
    }

    private loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getSDBridgeSummaryReportData(this.bridgeKeys).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }

    public exportToCsv(): void {
        const filename = 'SDBridgeSummaryReport.csv';
        let finalValue = '';

        // Fix lint error
        const index0 = 0;
        const index1 = 1;
        const index2 = 2;
        const index3 = 3;
        finalValue = `${this.headers[index0]},${this.headers[index1]},${this.headers[index2]},${this.headers[index3]},\n`;

        if (this.reportData.projects.length > 0) {
            const projects = this.reportData.projects;
            for (const project of projects) {
                const commaGlobalReplaceRegEx = /,/g;
                finalValue += `${project.structurallyDeficient.replace(commaGlobalReplaceRegEx, '')},${project.structurallyDeficient.replace(commaGlobalReplaceRegEx, '')},${project.structurallyDeficientDeckArea.replace(commaGlobalReplaceRegEx, '')},${project.nonStructurallyDeficient.replace(commaGlobalReplaceRegEx, '')},${project.nonStructurallyDefDeckArea.replace(commaGlobalReplaceRegEx, '')},\n`;
            }
        }

        const blob = new Blob([finalValue], { type: 'text/csv;charset-utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            const myLink: any = link;
            if (myLink.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                myLink.setAttribute('href', url);
                myLink.setAttribute('download', filename);
                myLink.style.visibility = 'hidden';
                document.body.appendChild(myLink);
                myLink.click();
                document.body.removeChild(myLink);
            }
        }
    }
}
